import { render } from "./bookingDetailComponent.vue?vue&type=template&id=1c5e777e"
import script from "./bookingDetailComponent.vue?vue&type=script&lang=js"
export * from "./bookingDetailComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__